(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* FIX-SP-02 2026-06-01 — Bag button -> cart drawer wiring.
     Addresses 2 BLOCKING WCAG 4.1.2 violations from a11y-engineer verification:
     (1) aria-controls="cart-drawer" was dangling — fixed by adding id="cart-drawer"
         to dialog in header-actions.liquid:162.
     (2) aria-expanded was hardcoded "false" with no toggle.

     S1 FIX ROUND 2 (2026-08-05, /qa items 1+2 — see .ledge/reviews/
     PT-checkpoints-preorder-flow.md "S1 /qa outcome"): this handler used to
     (a) call dialog.showModal() directly AND set aria-expanded itself, and
     (b) separately re-derive aria-expanded via 'dialog:open'/'dialog:close'
     listeners attached to <cart-drawer-component> at script-execution time.
     Both were live defects:
       - (a) bypassed DialogComponent#showDialog(), so the outside-click-to-
         close wiring (#handleClick, wired INSIDE showDialog() —
         assets/dialog.js:54-147) never got attached on the bag-icon path.
         Outside-click dismissal silently didn't work for drawers opened via
         the bag icon.
       - (b) attached its listeners at IIFE-execution time, which is BEFORE
         the ATC auto-open path can fire at realistic page dwell (~2-3s
         after load): a real Add-to-cart could dispatch the first
         'dialog:open' before this IIFE's listener existed, permanently
         desyncing aria-expanded from the actually-open dialog.

     Fixed by routing the bag icon through the SAME open() method the hidden
     Horizon-internal trigger already uses (header-actions.liquid's
     on:click="/open" button) — CartDrawerComponent#open() ->
     DialogComponent#showDialog(trigger), which guarantees outside-click +
     Escape + focus-return wiring on every open path uniformly. aria-expanded
     sync is no longer this IIFE's job at all — it now lives INSIDE
     CartDrawerComponent's own lifecycle (assets/cart-drawer.js
     connectedCallback), which listens for 'dialog:open'/'dialog:close' from
     the moment the component is defined, before any dialog:open can fire.
     That makes both prior failure modes structurally impossible instead of
     load-order-dependent. This handler's only remaining job is: click ->
     open the drawer through the one canonical open path. */
  (function () {
    var bagBtn = document.querySelector('[data-cart-open]');
    var cartDrawerComponent = document.querySelector('cart-drawer-component');
    if (!bagBtn || !cartDrawerComponent) return;

    bagBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (typeof cartDrawerComponent.open === 'function') {
        cartDrawerComponent.open(e);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-buy-box"] && !Shopify.designMode) return;
  try {
    
/*
 * PDP Buy-Box — Gallery Tablist JS
 * Implements APG Tabs pattern (vertical orientation, automatic activation).
 * Contract: .ledge/sprints/v2-rebuild/sprint-1/01-PLAN-tablist-contract.md §2
 *
 * Responsibilities:
 *   1. Keyboard navigation: ArrowDown/Up/Home/End with wrap-around (§2.2)
 *   2. Roving tabindex: selected tab tabindex=0, others -1 (§1.4)
 *   3. aria-selected updates (§1.2)
 *   4. aria-labelledby on tabpanel (§1.1)
 *   5. Main image swap (src + alt)
 *   6. Live region announcement "Image N of M" on selection change (§3)
 *   7. Activation model: AUTOMATIC — focus = selection (§2.3)
 *   8. Pointer/touch: update state but do NOT steal focus (§1.4 rule 3)
 *
 * ArrowLeft/ArrowRight are NO-OPS (vertical orientation per §2.2).
 * Tab key is handled by native browser behaviour via roving tabindex — no JS needed.
 */
(function () {
  'use strict';

  function initGallery(tablist) {
    var tabs = Array.prototype.slice.call(
      tablist.querySelectorAll('[role="tab"]')
    );
    if (!tabs.length) return;

    /* Derive section-scoped ids from tablist and panel */
    var panel      = tablist.closest('[data-lotusun-reveal]')
                       ? tablist.closest('[data-lotusun-reveal]').querySelector('[data-pdp-panel]')
                       : document.querySelector('[data-pdp-panel]');
    var liveRegion = tablist.closest('[data-lotusun-reveal]')
                       ? tablist.closest('[data-lotusun-reveal]').querySelector('[data-pdp-gallery-status]')
                       : document.querySelector('[data-pdp-gallery-status]');
    var mainImg    = panel && panel.querySelector('img.lotusun-buy-box__main-img');
    /* FIX-SP-02 delta 2026-06-01: visible counter ("N / total") was rendered
       once at server-side with initial "1" but never updated on tab change.
       Find the counter span via section-scoped id and update its textContent
       in selectTab() so the visible counter matches the active thumb. */
    var counter   = tablist.closest('[data-lotusun-reveal]')
                       ? tablist.closest('[data-lotusun-reveal]').querySelector('.lotusun-buy-box__image-counter span')
                       : document.querySelector('.lotusun-buy-box__image-counter span');
    var currentIdx = 0;

    /* ── helpers ── */
    function announce(idx) {
      if (!liveRegion) return;
      /* Only announce on CHANGE (not on load — §3.4) */
      var tmpl = liveRegion.getAttribute('data-label-template') || 'Image {n} of {total}';
      var str  = tmpl
        .replace('{n}',     String(idx + 1))
        .replace('{total}', String(tabs.length));
      /* Force AT re-read by clearing then setting textContent */
      liveRegion.textContent = '';
      /* Defer re-set to next paint so AT receives mutation */
      setTimeout(function () { liveRegion.textContent = str; }, 0);
    }

    function selectTab(newIdx, moveFocus) {
      if (newIdx === currentIdx) return;
      var prevIdx = currentIdx;
      currentIdx  = newIdx;

      /* Step 1 of §1.4: deselect all */
      tabs.forEach(function (tab) {
        tab.setAttribute('aria-selected', 'false');
        tab.setAttribute('tabindex', '-1');
        tab.classList.remove('lotusun-buy-box__thumb--active');
      });

      /* Step 2: select new */
      var newTab = tabs[newIdx];
      newTab.setAttribute('aria-selected', 'true');
      newTab.setAttribute('tabindex', '0');
      newTab.classList.add('lotusun-buy-box__thumb--active');

      /* Step 4: update tabpanel aria-labelledby */
      if (panel) {
        panel.setAttribute('aria-labelledby', newTab.id);
      }

      /* FIX-SP-02 delta 2026-06-01: update visible counter "N / total"
         The counter span at server-render was static "1"; now reflects active idx. */
      if (counter) {
        counter.textContent = String(newIdx + 1);
      }

      /* Step 3: move focus only on keyboard-initiated selection */
      if (moveFocus) {
        newTab.focus();
      }

      /* Image swap */
      if (mainImg) {
        var newSrc = newTab.getAttribute('data-image-src');
        var newAlt = newTab.getAttribute('data-image-alt');
        if (newSrc) {
          mainImg.classList.add('is-swapping');
          /* Swap after 80ms (duration-base / 2.5 — brief crossfade) */
          setTimeout(function () {
            /*
             * FIX (v211-fix sp-01-d): clear srcset BEFORE setting src.
             * image_tag emits a srcset attribute for responsive images; the
             * browser uses srcset over src, so setting src alone has no visible
             * effect. Clearing srcset forces the browser to use the plain src
             * URL (data-image-src = CDN URL at width:1200 — sufficient for the
             * main-image display area). sizes is also cleared so the browser
             * does not attempt a srcset lookup with a stale sizes string.
             */
            if (newSrc) {
              mainImg.removeAttribute('srcset');
              mainImg.removeAttribute('sizes');
              mainImg.src = newSrc;
            }
            if (newAlt) mainImg.alt = newAlt;
            mainImg.classList.remove('is-swapping');
          }, 80);
        }
      }

      /* Step 5: fire live region (§3.2 — after swap, on selection change) */
      announce(newIdx);
    }

    /* ── keyboard handler — §2.2 (vertical orientation) ── */
    tablist.addEventListener('keydown', function (e) {
      var key = e.key;
      /* ArrowLeft / ArrowRight are NO-OPS in vertical orientation (§2.2) */
      if (key === 'ArrowLeft' || key === 'ArrowRight') return;

      var newIdx;
      if (key === 'ArrowDown') {
        e.preventDefault();
        newIdx = (currentIdx + 1) % tabs.length;          /* wrap-around */
        selectTab(newIdx, true);                           /* moveFocus=true */
      } else if (key === 'ArrowUp') {
        e.preventDefault();
        newIdx = (currentIdx - 1 + tabs.length) % tabs.length;
        selectTab(newIdx, true);
      } else if (key === 'Home') {
        e.preventDefault();
        selectTab(0, true);
      } else if (key === 'End') {
        e.preventDefault();
        selectTab(tabs.length - 1, true);
      }
      /* Tab key: browser handles natively via roving tabindex — no override */
    });

    /* ── pointer / touch handler — §1.4 rule 3 (no focus steal) ── */
    tabs.forEach(function (tab, idx) {
      tab.addEventListener('click', function () {
        selectTab(idx, false);   /* moveFocus=false — pointer must not steal focus */
      });
    });

    /* ── swipe gesture on the main image — S8 ws-m2-pdp-thumb-path ──
       Mobile gallery affordance: swipe left/right on the tabpanel to
       move to the next/previous image, same wrap-around and
       moveFocus=false rule as the pointer handler above (touch must
       not steal focus). Gesture-intent classification (interaction
       physics discipline): a horizontal-dominant drag past a fixed
       threshold is a swipe; anything more vertical, or shorter than
       the threshold, is a page scroll or a tap and is left alone —
       listeners are { passive: true } throughout, so native vertical
       scroll is never blocked, satisfying it without preventDefault. */
    if (panel) {
      var touchStartX = 0;
      var touchStartY = 0;
      var SWIPE_THRESHOLD_PX = 40;

      panel.addEventListener('touchstart', function (e) {
        if (!e.touches || e.touches.length !== 1) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });

      panel.addEventListener('touchend', function (e) {
        if (!e.changedTouches || e.changedTouches.length !== 1) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;
        if (Math.abs(dx) < SWIPE_THRESHOLD_PX || Math.abs(dx) <= Math.abs(dy)) return;
        var swipeIdx = (dx < 0)
          ? (currentIdx + 1) % tabs.length                  /* swipe left  -> next, wrap */
          : (currentIdx - 1 + tabs.length) % tabs.length;   /* swipe right -> prev, wrap */
        selectTab(swipeIdx, false);
      }, { passive: true });
    }
  }

  /* Boot on DOMContentLoaded — supports both theme editor (section re-render) and navigation */
  function boot() {
    var tablists = document.querySelectorAll('[data-pdp-tablist]');
    tablists.forEach(function (tl) { initGallery(tl); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
